// extracted by mini-css-extract-plugin
export default {"table":"styles_table__Qv84v","roundTrip":"styles_roundTrip__Pa2yW"};